import type { SchemaField } from '../../../types/schede'
import TextField from './fields/TextField'
import NumberField from './fields/NumberField'
import DateField from './fields/DateField'
import SelectField from './fields/SelectField'
import CheckboxField from './fields/CheckboxField'
import RadioField from './fields/RadioField'
import TableField from './fields/TableField'
import SectionField from './fields/SectionField'
import CalculatedField from './fields/CalculatedField'
import SignatureField from './fields/SignatureField'
import PhotoField from './fields/PhotoField'
import FileField from './fields/FileField'
import ReadonlyField from './fields/ReadonlyField'
import TextareaField from './fields/TextareaField'
import DbLookupField from './fields/DbLookupField'
import LabelField from './fields/LabelField'

interface FieldRendererProps {
  field: SchemaField
  value: any
  onChange: (value: any) => void
  readOnly?: boolean
  error?: string
  allDati?: Record<string, any>
}

export default function FieldRenderer({ field, value, onChange, readOnly = false, error, allDati: _allDati }: FieldRendererProps) {
  void _allDati
  const commonProps = { field, value, onChange, readOnly, error }

  switch (field.type) {
    case 'text':
      return <TextField {...commonProps} />
    case 'textarea':
      return <TextareaField {...commonProps} />
    case 'number':
      return <NumberField {...commonProps} />
    case 'date':
      return <DateField {...commonProps} />
    case 'select':
      return <SelectField {...commonProps} />
    case 'checkbox':
      return <CheckboxField {...commonProps} />
    case 'radio':
      return <RadioField {...commonProps} />
    case 'table':
      return <TableField {...commonProps} />
    case 'section':
      return <SectionField {...commonProps} />
    case 'calculated':
      return <CalculatedField {...commonProps} />
    case 'signature':
      return <SignatureField {...commonProps} />
    case 'photo':
      return <PhotoField {...commonProps} />
    case 'file':
      return <FileField {...commonProps} />
    case 'readonly':
      return <ReadonlyField {...commonProps} />
    case 'db_lookup':
      return <DbLookupField {...commonProps} />
    case 'label':
      return <LabelField {...commonProps} />
    default:
      return (
        <div className="p-2 text-xs rounded border" style={{ borderColor: 'var(--color-border)', color: 'var(--color-text-tertiary)' }}>
          Tipo campo non supportato: {field.type}
        </div>
      )
  }
}
